import { DEVURL, PPURL, SITURL } from '../Constants';
import HookLoader from './HookLoader/HookLoader';
import useToken from './useToken';

const win: any = window;
const baseUrl = window.location.origin.includes('localhost') ? "http://ssta004:8080" : window.location.origin;

interface BMProps {
  setBMToken: (flag: boolean) => void
}

const BMToken = ({ setBMToken }: BMProps) => {
  let utilUrl = baseUrl;

  if (baseUrl.includes('apisit')) {
      utilUrl = SITURL;
  } else if (baseUrl.includes('apipreprod')) {
      utilUrl = PPURL;
  } else if (baseUrl.includes('apidev')) {
      utilUrl = DEVURL;
  }
  
  const url = `${utilUrl}/mobilyTheme4/BzFvwmzXvs`;
  const req = { "dataT": "bm" }
  const { response, loading } = useToken(url, req, setBMToken);

  if (response) {
    !!!win["bmToken"] && (win["bmToken"] = response);
  }

  return (
    <>
      {loading && <HookLoader loading={loading} />}
    </>
  )
}

export { BMToken }